export default __webpack_public_path__ + "static/media/apg.1ece343f.png";